import superMeta from '../_COMMON/metaCommonNode.mjs'

export default {
    ...superMeta,
    name: '属性',
    type: 'DPPROP',
}
